import React from 'react';
import dayjs from 'dayjs';
import { GetOrgOverviewMetrics } from '@/components/orgOverview/orgOverviewHelpers';
import { MIN_ORG_METRIC_PERIOD_IN_DAYS } from './OrgOverviewDatePickerTimeRange';
import { OrgNavigationDateRangeType } from './OrgNavigationDateRange';
import { OrgNavigationFilters } from './OrgNavigationContent';

interface OrgNavigationFiltersContextValue {
    filters: OrgNavigationFilters;
    setFilters: React.Dispatch<React.SetStateAction<OrgNavigationFilters>>;
}

const OrgNavigationFiltersContext = React.createContext<OrgNavigationFiltersContextValue | null>(null);

export const createDefaultOrgNavigationFilters = (): OrgNavigationFilters => {
    const startDate = dayjs().subtract(MIN_ORG_METRIC_PERIOD_IN_DAYS, 'days');
    const endDate = dayjs();

    return {
        selectedDateRangeType: OrgNavigationDateRangeType.Custom,
        selectedDateRange: {
            start: startDate.format('YYYY-MM-DD'),
            end: endDate.format('YYYY-MM-DD'),
        },
        selectedMetrics: GetOrgOverviewMetrics(),
        selectedWorkflowApps: {},
        selectedDestinations: {},
        selectedLegacyApps: {},
        selectedPlatforms: {},
        selectedUsers: {},
        shouldGenerateInsights: false,
    };
};

export const OrgNavigationFiltersProvider: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const [filters, setFilters] = React.useState<OrgNavigationFilters>(createDefaultOrgNavigationFilters);

    return (
        <OrgNavigationFiltersContext.Provider
            value={{
                filters,
                setFilters,
            }}
        >
            {children}
        </OrgNavigationFiltersContext.Provider>
    );
};

export const useOrgNavigationFilters = (): OrgNavigationFiltersContextValue => {
    const context = React.useContext(OrgNavigationFiltersContext);

    if (!context) {
        throw new Error('useOrgNavigationFilters must be used within OrgNavigationFiltersProvider');
    }

    return context;
};
